import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { customerServicePageBreadcrumbs } from './config';
import { ROLES } from '@/components/security/AppRoles';
import { Authorize, NavigateLinks } from '@/components';
import {
  AssignmentOutlined,
  EventNoteOutlined,
  InsightsOutlined,
  MonitorHeartOutlined,
  ReceiptLongOutlined,
  TuneOutlined,
} from '@mui/icons-material';
import ModuleTile from './components/ModuleTile';

const ICON_SIZE = { fontSize: 44 };

export const CustomerService = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => customerServicePageBreadcrumbs(navigate),
    []
  );
  return (
    <section className='flex h-full w-full flex-col gap-8 p-5'>
      <NavigateLinks
        actualPage='Atención al Cliente'
        breadcrumbs={breadcrumbs}
      />
      <section className='flex h-full w-full flex-col items-center'>
        <ul className='grid h-full w-full max-w-[calc(6*200px+5*50px)] grid-cols-[repeat(auto-fit,200px)] content-center justify-center gap-[50px]'>
          <ModuleTile
            icon={<AssignmentOutlined sx={ICON_SIZE} />}
            label='Casos'
            tone='violet'
            onClick={() => navigate('/atc/cases')}
          />
          <Authorize permission={ROLES.ATC.access}>
            <ModuleTile
              icon={<EventNoteOutlined sx={ICON_SIZE} />}
              label='Minutas'
              tone='sky'
              onClick={() => navigate('/atc/minutes')}
            />
          </Authorize>
          <Authorize permission={ROLES.ATC.access}>
            <ModuleTile
              icon={<ReceiptLongOutlined sx={ICON_SIZE} />}
              label='Facturas'
              tone='emerald'
              onClick={() => navigate('/atc/invoices')}
            />
          </Authorize>
          <Authorize permission={ROLES.ATC.access}>
            <ModuleTile
              icon={<InsightsOutlined sx={ICON_SIZE} />}
              label='Métricas de casos'
              tone='orange'
              onClick={() => navigate('/atc/cases-information')}
            />
          </Authorize>
          <Authorize permission={ROLES.ATC.admin}>
            <ModuleTile
              icon={<TuneOutlined sx={ICON_SIZE} />}
              label='Configurar'
              tone='slate'
              onClick={() => navigate('/atc/settings')}
            />
          </Authorize>
          <ModuleTile
            icon={<MonitorHeartOutlined sx={ICON_SIZE} />}
            label='Monitor'
            tone='rose'
            onClick={() => navigate('/atc/dashboard')}
          />
        </ul>
      </section>
    </section>
  );
};
